<template>
    <div class="content">
        <div class="card card-default">
            <div class="card-header">
                <h3 class="card-title"> </h3>
                <div class="card-tools">
                    <button type="button" class="btn btn-tool" data-toggle="dropdown" title="Công cụ">
                        <i class="fas fa-cogs"></i>
                        <div class="input-group-prepend">
                            <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
                                <a class="dropdown-item text-green" href="#" @click="detail(null, 'create')">
                                    <i class="fas fa-plus"></i>&nbsp;&nbsp;Tạo mới
                                </a>
                                <!-- <div class="dropdown-divider"></div>
                                <a class="dropdown-item text-red" href="#" @click="showDeleteManyModal()">
                                    <i class="fas fa-trash-restore-alt"></i>&nbsp;&nbsp;Xóa đã chọn
                                </a> -->
                                <div class="dropdown-divider"></div>
                                <export-excel class="dropdown-item text-green" :data="exportDatas" worksheet="workspace" type="xls" name="workspace.xls">
                                    <i class="fas fa-file-excel"></i>&nbsp;&nbsp;Xuất file Excel
                                </export-excel>
                                <div class="dropdown-divider"></div>
                            </div>
                        </div>
                    </button>
                    <button type="button" class="btn btn-tool" @click="getData" title="Tải lại">
                        <i class="fas fa-arrows-rotate"></i>
                    </button>
                    <!-- <button type="button" class="btn btn-tool" data-card-widget="collapse" title="Thu gọn">
                        <i class="fas fa-minus"></i>
                    </button>
                    <button type="button" class="btn btn-tool" data-card-widget="remove" title="Ẩn">
                        <i class="fas fa-times"></i>
                    </button> -->

                </div>
            </div>
            <!-- /.card-header -->
            <div class="card-body">
                <div class="row mb-2">
                    <div class="col-md-3 mb-3">
                        <TheSelect id="" title="" :options="pageOptions" :initialValue="perPage.toString()" @onChange="(v) => onChangePageOptions(v)" />
                    </div>
                    <div class="col-md-6"></div>
                    <div class="col-md-3">
                        <div class="input-group mb-3">
                            <input type="text" class="form-control" placeholder="Nhập  từ khóa tìm kiếm" v-model="filter" v-on:keyup.enter="onSearchKey">
                            <div class="input-group-append">
                                <span class="input-group-text" @click="onSearchKey" role="button">
                                    <i class="fas fa-search"></i>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="table-responsive p-0">
                    <!-- loading overlay -->
                    <loading :active="isBusy" class="text-center" color="#000000" loader="spinner"></loading>
                    <!-- table data -->
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th class="col5">#</th>
                                <th class="col80">Tên TTĐH</th>
                                <th class="col80 text-center">Logo</th>
                                <th class="col80">Tên Workspace</th>
                                <th>Loại Workspace</th>
                                <th class="col200"></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in items" :key="item.id">
                                <td style="vertical-align: middle !important;">{{ index + 1 }}</td>
                                <td style="vertical-align: middle;">{{ item.operatingCenterName }}</td>
                                <td style="vertical-align: middle;" class="text-center">
                                    <img :src="(item.operatingCenterLogo != null && item.operatingCenterLogo.trim().length > 0) ? (streamFileUrl + item.operatingCenterLogo) : require('@/assets/default-operating-center.png')" width="100"/>
                                </td>
                                <td style="vertical-align: middle;">{{ item.workspaceName }}</td>
                                <td style="vertical-align: middle;">{{ item.workspaceType }}</td>
                                <td style="vertical-align: middle;">
                                    <button type="button" size="sm" class="btn btn-outline-warning btn-xs"
                                        v-on:click="detail(item, 'update')">
                                        <i class="fas fa-pencil-alt"></i>
                                    </button>&nbsp;

                                    <router-link :to="'/admin/role-workspace?id=' + item.id" size="sm" class="btn btn-outline-primary btn-xs mr-1" title="Phân quyền Workspace">
                                        <i class="fa-solid fa-user-tag nav-icon"></i>
                                    </router-link>
                                    
                                    <button type="button" size="sm" class="btn btn-outline-danger btn-xs" v-on:click="showDeleteConfirm(item.id)" title="Xóa">
                                        <i class="fas fa-trash-alt"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- <p> Selected Rows:<br>{{ selected }} </p> -->
                <!-- row info and paging -->
                <div class="row">
                    <div class="col-md-6">
                        <div v-if="totalRow != 0">Hiển thị {{ numberOfShow }} trên tổng số {{ totalRow }} dòng</div>
                        <div v-else>Không có dữ liệu</div>
                    </div>
                    <div class="col-md-6">
                        <div class="float-right">
                            <ul class="pagination pagination-rounded">
                                <paginate :page-count="pageCount" :page-range="3" :margin-pages="2"
                                    :click-handler="handlePageChange" :prev-text="'Trở lại'" :next-text="'Kế đến'"
                                    :container-class="'pagination'" :page-class="'page-item'">
                                </paginate>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!--POP UP DETAIL-->
        <div class="modal fade" id="detailModal" data-keyboard="false" data-backdrop="dynamic"> <!-- data-backdrop="static" -->
            <div class="modal-dialog modal-lg">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title">{{ title }}</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideDetailModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- <input type="hidden" v-model="model.id" /> -->
                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Tên Trung tâm điều hành <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <input class="form-control" placeholder="Nhập tên Trung tâm điều hành" v-model="model.operatingCenterName"  @blur="validate()" :class="{ 'is-invalid': errors.operatingCenterName }" />
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" style="margin-top: -13 !important;" v-if="errors.fullname">{{ errors.operatingCenterName }}</small>

                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Hình ảnh
                            </label>
                            <div class="col-sm-9">
                                <div class="custom-file">
                                    <input type="file" class="custom-file-input" id="customFile" @change="onChangeOperatingCenterLogo($event)">
                                    <label class="custom-file-label" for="customFile">Choose file</label>
                                </div>
                            </div>
                            <div class="col-sm-3"></div>
                            <div class="col-sm-9">
                                <div class="image-preview mt-2" v-if="this.model.localImageUrl != null">
                                    <img v-bind:src="this.model.localImageUrl" width="100" style="border: 1px solid #d1cece; padding: 10px; border-radius: 5px;">
                                    <button class="btn btn-sm" v-on:click="onClearOperatingCenterLogo()">
                                        <i class="fas fa-trash-alt ml-2 text-danger clear-image"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" v-if="errors.localImage">{{ errors.localImage }}</small>

                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Tên Workspace <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">
                                <input class="form-control" placeholder="Nhập tên Workspace" v-model="model.workspaceName"  @blur="validate()" :class="{ 'is-invalid': errors.workspaceName }" :readonly="code == 'update'"/>
                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" style="margin-top: -13 !important;" v-if="errors.fullname">{{ errors.workspaceName }}</small>

                        <div class="row mb-2">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Loại Workspace <span class="text-danger">(*)</span>
                            </label>
                            <div class="col-sm-9">

                                <select id="workspaceTypeOptions" class="form-control" :class="{ 'is-invalid': errors.workspaceName }" style="width: 100%" v-model="model.workspaceType" @change="validate()" :readonly="code == 'update'">
                                    <option v-for="item in workspaceTypeOptions" :value="item" :key="item">{{ item }}</option>
                                </select>

                            </div>
                        </div>
                        <small class="text-danger text-right mb-2 d-block" v-if="errors.workspaceType">{{ errors.workspaceType }}</small>

                        <div class="row mb-2" v-if="code == 'update'">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                 
                            </label>
                            <div class="col-sm-9">

                                <div class="custom-control custom-checkbox">
                                    <input type="checkbox" class="custom-control-input" id="isUsePBIHome" v-model="model.isUsePBIHome">
                                    <label class="custom-control-label" for="isUsePBIHome">Trang chủ là file Power BI</label>
                                </div>

                            </div>
                        </div>

                        <div class="row mb-2" v-if="code == 'update' && model.isUsePBIHome">
                            <label for="" class="col-sm-3 col-form-label" style="text-align:right">
                                Report <span class="text-danger"></span>
                            </label>
                            <div class="col-sm-9">

                                <select id="reportOptions" class="form-control" style="width: 100%" v-model="model.reportId">
                                    <option v-for="item in reportOptions" :value="item.id" :key="item.id" :selected="model.reportId">{{ item.reportName }}</option>
                                </select>

                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideDetailModal()">&nbsp;Đóng</button>
                        <button type="button" class="pull-right" :disabled="submitted" :class="styleButton" v-if="code != 'detail'" @click="onSubmit();">
                            <span v-if="submitted" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            &nbsp;{{ title }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
        <!-- POP UP CONFIRM DELETE  -->
        <div class="modal fade" id="deleteConfirm" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-danger">Xóa Workspace</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideDeleteConfirm()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <label>Xóa Workspace này?</label>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideDeleteConfirm()">&nbsp;Đóng</button>
                        <button type="button" class="btn btn-outline-danger pull-right" @click="onSubmitDelete();">&nbsp;Xóa</button>
                    </div>
                </div>
            </div>
        </div>
        <!-- POP UP CONFIRM DELETE MANY  -->
        <div class="modal fade" id="deleteManyModal" data-keyboard="false" data-backdrop="static">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title text-danger">Xóa</h4>
                        <button type="button" class="close" aria-label="Close" @click="hideDeleteManyModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <label>Bạn có chắc chắn xóa các item đã chọn?</label>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="btn btn-outline-dark pull-left" @click="hideDeleteManyModal()">&nbsp;Đóng</button>
                        <button type="button" class="btn btn-outline-danger pull-right" @click="onDeleteManySubmit();">&nbsp;Xóa</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { mapActions } from 'vuex';
import { workspaceModel } from '@/models/workspace.model.js';
import config from '@/config/prod.env';
import Paginate from "vuejs-paginate-next";
import Loading from "vue3-loading-overlay";
import TheSelect from '@/components/shared/UserInput/TheSelect.vue';

export default {
    components: {
        paginate: Paginate,
        loading: Loading,
        TheSelect
    },
    name: "TheReport",
    data() {
        return {
            isBusy: false,
            streamFileUrl: `${process.env.VUE_APP_API_URL}/Common/StreamFile?url=`,
            // table
            filter: null,
            items: [],
            exportDatas: [],
            currentPage: config.CURRENT_PAGE,
            perPage: config.DEFAULT_LIMIT,
            pageOptions: config.PAGE_OPTION,
            totalRow: 0,
            pageCount: 0,
            sortBy: "createdDate",
            sortDesc: true,
            filterOn: [],
            numberOfShow: 0,
            // model 
            model: workspaceModel.newModel(),

            workspaceTypeOptions: ['web', 'mobile'],

            reportOptions: [],

            selectedId: '',
            newPass: "",

            title: "",
            code: "",
            styleButton: "",
            // For mesage validate
            errors: {},
            submitted: false,
            selected: [],
            rowSelected: null,
            isUpdate: false
        }
    },
    methods: {
        // Map action
        ...mapActions('header', ['setupHeader',]),
        ...mapActions('workspace', ['getAllWorkspacePaging', 'createWorkspace', 'updateWorkspace', 'deleteWorkspace']),
        ...mapActions('report', ['getActiveReportByWorkspaceId']),
        ...mapActions('alert', ['warning',]),
        // setup
        async setup() {
            //setup dynamic header
            let header = 'Quản lý Workspace';
            this.setupHeader({ header });
        },

        // ------ get data datatable ------
        async getData() {
            // state for loading overlay
            this.isBusy = true;
            // Set param for paging
            let params = {
                currentPage: this.currentPage,
                perPage: this.perPage,
                sortBy: this.sortBy,
                sortDesc: this.sortDesc,
                searchKey: this.filter
            };
            // Call get data
            let rs = await this.getAllWorkspacePaging(params);
            if(rs.isOk) {
                // List data
                this.items = rs.data.data;
                // Total row
                this.totalRow = rs.data.totalRow;
                // Number show
                this.numberOfShow = ((this.currentPage - 1) * this.perPage) + this.items.length;
                // Total number page
                this.pageCount = parseInt(((this.totalRow - 1) / this.perPage)) + 1;
                // For export excel
                this.exportDatas = this.items.map(({ rowNumber, id, operatingCenterName, workspaceName, workspaceType }) => ({
                    rowNumber, id, operatingCenterName, workspaceName, workspaceType
                }));
            }
            this.isBusy = false;
        },        
        // sortingChanged
        async sortingChanged() {
            //console.log(this.perPage)
            await this.getData();
        },
        // function for paging
        async handlePageChange(page) {
            this.currentPage = page;
            //console.log(this.currentPage)
            await this.getData();
        },
        // function for select number in page
        async onChangePageOptions(perPage) {
            this.perPage = perPage;
            await this.getData();
        },
        // function for search key 
        async onSearchKey() {
            //console.log(this.filter)
            //this.filter = e.target.value
            await this.getData();
        },
        
        // ------ show/hide detail popup ------
        async detail(item, code) {
            // set notifi error
            this.errors = {
                
            };
            // prepare model
            this.code = code;
            this.title = this.$t('labels.' + code);
            this.styleButton = this.$t('labels.styleButton' + code);
            this.model = item != null ? JSON.parse(JSON.stringify(item)) : workspaceModel.newModel();
            this.isUpdate = (code == "create") ? false : true;

            if(item && this.model.operatingCenterLogo && this.model.operatingCenterLogo.trim().length > 0) {
                this.model.localImageUrl = this.streamFileUrl + item.operatingCenterLogo;
            }            

            // get reports by workpaceId
            this.isBusy = true;
            let res = await this.getActiveReportByWorkspaceId(this.model.id);
            if(res.isOk) {
                this.reportOptions = res.data.data;
            }
            this.isBusy = false;

            // show popup
            this.showDetailModal();
        },
        async showDetailModal() {
            $('#detailModal').modal('show');
        },
        async hideDetailModal() {
            $('#detailModal').modal('hide');
            await this.getData();
        },

        // ------ on change operating center logo (create, update) -------
        onChangeOperatingCenterLogo(event) {
            if(event.target.files.length > 0) {
                this.model.localImage = event.target.files[0];
                this.model.localImageUrl = URL.createObjectURL(this.model.localImage);
                this.model.isChangedImage = true;
            }
        },

        // ------ on clear report image (create, update) ------
        onClearOperatingCenterLogo(){
            this.model.localImage = null;
            this.model.localImageUrl = null;
            this.model.isChangedImage = true;
        },

        // ------ show/hide delete confirm ------
        async showDeleteConfirm(id) {
            this.selectedId = id;
            $('#deleteConfirm').modal('show');
        },
        async hideDeleteConfirm() {
            $('#deleteConfirm').modal('hide');
        },

        // ------ function validate ------
        async validate() {
            let isvalid = true
            this.errors = {
                operatingCenterName: '',
                workspaceName: '',
                workspaceType: '',
                localImage: '',
            };

            // check null model
            if (!this.model.operatingCenterName) {
                this.errors.operatingCenterName = "Nhập tên Trung tâm điều hành";
                isvalid = false;
            }
            if (!this.model.workspaceName) {
                this.errors.workspaceName = "Nhập tên workspace";
                isvalid = false;
            }
            if (!this.model.workspaceType) {
                this.errors.workspaceType = 'Chọn loại workspace';
                isvalid = false;
            }
            let imageType = ["image/gif", "image/jpeg", "image/png"];
            if(this.model.localImage && !imageType.includes(this.model.localImage.type)) {
                this.errors.localImage = 'Không phải hình ảnh';
                isvalid = false;
            }
            return isvalid;
        },

        // ------ create, update submit ------
        async onSubmit() {
            this.submitted = true;
            if (await this.validate()) {
                // create
                if (this.code == "create") {
                    await this.createWorkspace(this.model);
                }
                // update
                if (this.code == "update") {
                    await this.updateWorkspace(this.model);
                }
                this.hideDetailModal();
                await this.getData();
            }
            this.submitted = false;
        },

        // ------ delete submit ------
        async onSubmitDelete() {
            await this.deleteWorkspace(this.selectedId);
            this.getData();
            this.hideDeleteConfirm();
        },
    },
    async mounted() {
        // setup title header
        await this.setup();
        // get data table
        await this.getData();
    },
    async created() {

    }
}
</script>

<style>

</style>
